import { LeadPotentialSellerCount } from './leadPotentialSellerCount';

export class LeadsPotentialSellersCountResponse {
    leads: LeadPotentialSellerCount[];
}
